import { createFileRoute } from '@tanstack/react-router';
import { HelpCenterPage } from '@/pages/help/HelpCenterPage';

export const Route = createFileRoute('/$slug/help/')({
  component: HelpCenterPage
});
